import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9sm8l1lk96: FaireBrandEntity = {
  token: "b_9sm8l1lk96",
  type: "brand",
  name: "Lane Seven Apparel",
  avatarUrl:
    "https://cdn.faire.com/fastly/9044a6ed63d5ddc1720e0b362907721c304fb6ec008a352618e8f76455d498a3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e64cb18e6cbbbbdf61ec4ebdeb7c61f28a05a4a49ec962d7de99f5753b985100.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9044a6ed63d5ddc1720e0b362907721c304fb6ec008a352618e8f76455d498a3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e64cb18e6cbbbbdf61ec4ebdeb7c61f28a05a4a49ec962d7de99f5753b985100.png",
  location: "Irwindale, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 220,
  isTopShop: true,
  isInsider: true,
  description:
    "Lane Seven Apparel offers a diverse selection of blanks and basics for your retail store! \n\nConceptualized and Distributed from Los Angeles, CA.\nOur product matrix include collections of light to heavy weight t-shirts, fleece products, and polo/golf shirts. We also offer custom manufacturing programs for a wide variety of promotional and hospitality apparel.\n\nAll our products come with tear-away labels and can be easily re-labelled so you have the ease and comfort to use either our private label or use your own brand labels. Our distribution is based in Los Angeles, California with satellite offices in the mid-west and the east coast.\n\nAll our manufacturing is done in vertically integrated, ethically responsible and socially compliant plants with industry leading certifications. All production is subject to in-line audits and final random audits prior to shipment to ensure the utmost in quality levels.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:09.506Z",
    importedBy: "entity-db-cli",
  },
};
